import en from "./app.lang.en.js";
import ru from "./app.lang.ru.js";
import ja from "./app.lang.ja.js";
import es from "./app.lang.es.js";

let data = {
  en,
  ru,
  ja,
  es
};

export default {
  texts(block) {
    return data[window['CURRENT_LANGUAGE']][block];
  }
}